export const Auxiliary = props => props.children;
